import React from "react";
import { Link } from "react-router-dom";

export default function DashboardSidebar() {
  return (
    <aside style={styles.sidebar}>
      <div style={styles.logoArea}>
        <h2 style={styles.logoText}>Dashboard</h2>
      </div>

      <nav style={styles.nav}>
        <ul style={styles.list}>
          <li>
            <Link to="/admin/dashboard/orders" style={styles.link}>
              Ordini
            </Link>
          </li>
          <li>
            <Link to="/admin/dashboard/kpi" style={styles.link}>
              KPI
            </Link>
          </li>
          <li>
            <Link to="/admin/dashboard/piatti" style={styles.link}>
              Piatti
            </Link>
          </li>
          <li>
            <Link to="/admin/dashboard/ai" style={styles.link}>
              AI
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
}

// Palette coerente con i tuoi design precedenti
const palette = {
  primary: "#FF8C00",
  secondary: "#FF6600",
  textLight: "#FFF",
};

const styles = {
  sidebar: {
    width: "240px",
    minHeight: "100vh",
    background: `linear-gradient(180deg, ${palette.primary} 0%, ${palette.secondary} 100%)`,
    color: palette.textLight,
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    boxShadow: "2px 0 8px rgba(0,0,0,0.2)",
    position: "relative",
    zIndex: 2,
  },
  logoArea: {
    marginBottom: "2rem",
    textAlign: "center",
    padding: "1rem",
    borderRadius: "10px",
    backgroundColor: "rgba(255,255,255,0.15)",
  },
  logoText: {
    margin: 0,
    fontSize: "1.4rem",
    fontWeight: "bold",
    letterSpacing: "1px",
  },
  nav: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  link: {
    display: "block",
    padding: "0.75rem 1rem",
    textDecoration: "none",
    color: palette.textLight,
    fontWeight: "bold",
    borderRadius: "6px",
    transition: "background 0.2s, transform 0.2s",
    // Effetto hover / focus
    ':hover': {
      background: "rgba(255,255,255,0.2)",
      transform: "translateX(4px)",
    },
  },
};
